<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-card v-on:keyup.enter="buildNewSearch">
			<v-card-title>
				<h2>Oferty</h2>
				<v-spacer></v-spacer>
			</v-card-title>

			<v-layout align-center justify-center row>
				<v-flex xs2>
					<v-text-field
						browser-autocomplete="off"
						class="ma-2"
						v-model="searchFields.offerCode"
						label="Nr oferty"
						aria-label="offer code"
					></v-text-field>
				</v-flex>
				<v-flex xs3>
					<v-autocomplete
						clearable
						class="ma-2"
						v-model="searchFields.contestName"
						label="Nazwa konkursu"
						aria-label="contest name"
						:items="contestNameList"
					></v-autocomplete>
				</v-flex>
				<v-flex xs3>
					<v-autocomplete
						clearable
						v-if="!onlyMine"
						class="ma-2"
						v-model="searchFields.bidderName"
						label="Nazwa oferenta"
						aria-label="bidder name"
						:items="bidderNameList"
					></v-autocomplete>
				</v-flex>
				<v-flex xs2>
					<v-autocomplete
						v-if="!onlyMine"
						class="ma-2"
						aria-label="legal form"
						v-model="searchFields.bidderLegalForm"
						:items="legalFormList"
						label="Forma prawna oferenta"
						clearable
					></v-autocomplete>
				</v-flex>
			</v-layout>
			<v-layout align-center justify-center row>
				<v-flex xs2>
					<v-autocomplete
						class="ma-2"
						v-model="searchFields.countryId"
						:items="countryList"
						item-text="name"
						item-value="id"
						label="Kraj oferty"
						aria-label="offer country"
						for="all-offers-list-view-offer-country"
						id="all-offers-list-view-offer-country"
						clearable
					></v-autocomplete>
				</v-flex>
				<v-flex xs2>
					<v-autocomplete
						class="ma-2"
						v-model="searchFields.realizationYear"
						:items="yearList"
						label="Rok realizacji"
						clearable
						aria-label="realization year"
					></v-autocomplete>
				</v-flex>
				<v-flex xs2>
					<v-autocomplete
						class="ma-2"
						v-model="searchFields.offerStatus"
						:items="statusList"
						item-text="statusPL"
						item-value="statusEN"
						label="Status oferty"
						clearable
						aria-label="offer status"
					></v-autocomplete>
				</v-flex>
				<v-flex xs4>
					<v-layout align-center justify-center>
						<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
						<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
						<v-btn @click="exportData" color="primary" dark class="ma-2">Eksportuj</v-btn>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-card>
		<v-card>
			<v-data-table
				:headers="headers"
				:rows-per-page-items="[10,20,25]"
				:items="offers"
				:pagination.sync="pagination"
				:total-items="itemCount"
				class="elevation-1">
				<template v-slot:items="props">
						<td>{{ props.item.code }}</td>
						<td>{{ props.item.name }}</td>
						<td>{{ formatMoneyWithCode(props.item.requestedDotation, 'PLN') }}</td>
						<td>
							<v-layout row>
								<v-flex shrink>
									{{ props.item.mainBidder }}
								</v-flex>
								<v-flex v-if="props.item.mutualOffer" pl-1 grow>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-icon v-on="on">groups</v-icon>
										</template>
										<span>Oferta wspólna z: {{ props.item.mutualBidderNames.join(", ") }}</span>
									</v-tooltip>
								</v-flex>
							</v-layout>
						</td>
						<td>{{printAllCountries(props.item)}}</td>
						<td>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn icon
										v-if="props.item.userReadOfferAccess"
										@click="viewOffer(props.item.contestId, props.item.id)">
										<v-icon v-on="on">
											description
										</v-icon>
									</v-btn>
								</template>
								<span>Podgląd oferty</span>
							</v-tooltip>
						</td>
				</template>
			</v-data-table>
		</v-card>
	</div>
</template>

<script>
	import {Api} from "@/api";
	import {AccreditationCountry} from "@/api/generated/AccreditationCountry";
	import {Pagination} from "@/utils/PaginationUtils";
	import {ContestRealizationYear} from "@/api/generated/ContestRealizationYear";
	import {ExportUtils} from "@/utils/ExportUtils";
	import {Offer} from "@/api/generated/Offer";
  import {Numbers} from "@/utils/Numbers";
  import {Filters} from "@/utils/Filters";
  import {getDictionary} from "@/utils/LegalFormDictionary";

	export default {
		name: "AllOffersListView",

		data() {
			return {
				searchFields: Pagination.initSearchedFields([
					"bidderName",
					"bidderLegalForm",
					"offerStatus",
					"onlyMine",
					"countryId",
					"realizationYear",
					'offerCode',
					'contestName'
				]),
				statusList: [
					{statusPL: "Oczekuje na akceptację", statusEN: "AWAITING_MAIN_BIDDER_ACCEPTANCE"},
					{statusPL: "Oczekuje na akceptację współoferentów", statusEN: "AWAITING_MUTUAL_BIDDERS_ACCEPTANCE"},
					{
						statusPL: "Oczekuje na akceptację zmian przez współoferenta",
						statusEN: "POST_CORRECTION_MUTUAL",
					},
					{
						statusPL: "Oczekuje na akceptację zmian",
						statusEN: "POST_CORRECTION_MAIN",
					},
					{statusPL: "Wysłana", statusEN: "SUBMITTED"},
					{statusPL: "Rezerwowa", statusEN: "RESERVED"},
					{statusPL: "Odrzucona", statusEN: "REJECTED"},
					{statusPL: "Finansowana", statusEN: "FINANCED"},
					{statusPL: "Niefinansowana", statusEN: "NOT_FINANCED"},
					{statusPL: "Realizowana", statusEN: "APPROVED"},
					{statusPL: "Oczekuje na poprawki", statusEN: "AWAITING_CORRECTION"},
				],
				countryList: [],
				headers: [
					{text: "Numer oferty", value: "code", align: "left", sortable: true},
					{text: "Nazwa oferty", value: "title", sortable: true},
					{text: "Kwota wnioskowana (moduł I)", value: "requestedDotation", sortable: false},
					{text: "Nazwa oferenta", value: "mainBidder", sortable: true},
					{text: "Kraje oferty", value: "mainCountry", sortable: true},
					{text: "Akcje", sortable: false}
				],
				itemCount: 0,
				pagination: {
					rowsPerPage: 25,
					sortBy: null
				},
				legalFormList: [],
				yearList: [],
				contestNameList: [],
				bidderNameList: [],
				search: "",
				offers: [],
			};
		},

		props: {
			onlyMine: {
				default: false,
			},
		},

    mixins: [Numbers, Filters],

		watch: {
			"pagination": {
				handler(pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			}
		},

		created() {
			this.getAllOffersContestNames();
			this.getAllOffersBidderNames();
		},

		mounted() {
			this.resetSearch();
			this.getCountryList();
			this.getYearList();
			this.getLegalFormList();
			this.removeEmptyTableLoading();
      this.searchFields = this.retrieveFilters(this.searchFields);
      this.pagination = this.retrievePagination(this.pagination);
      this.buildNewSearch();
    },

		methods: {
			getCountryList() {
				AccreditationCountry.get(this, successResponse => {
						this.countryList = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować krajów wolontariatu", errorResponse);
					});
			},

			buildNewSearch () {
				this.search = this.buildSearch();
				this.getItemList();
			},

			resetSearch() {
				Pagination.resetSearch(this.searchFields);
				this.search = "";
			},

			buildSearch() {
				return Pagination.buildSearchCriteria(this.searchFields, false);
			},

			buildSort() {
				let order = this.pagination.descending === true ? "desc" : "asc";
				let columnName = this.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			getLegalFormList() {
        let dict = getDictionary();
        for (let i = 0; i < Object.keys(dict).length; i++) {
          this.legalFormList.push(dict[i]);
        }
			},

			getYearList () {
				ContestRealizationYear.getList(this, successResponse => {
						this.yearList = successResponse.items.map(item => item.value);
						this.yearList.sort(function (x, y) {
							return y - x;
						});
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować lat realizacji projektów", errorResponse);
					});
			},

			getAllOffersContestNames () {
				Offer.getAllContestNames(this, false, successResponse => {
						this.contestNameList = successResponse.sort();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować nazw konkursów", errorResponse);
					});
			},

			getAllOffersBidderNames () {
				Offer.getAllBidderNames(this, successResponse => {
						this.bidderNameList = successResponse.sort();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować nazw oferentów", errorResponse);
					});
			},

			exportData () {
				let search = this.search;
				let sort = this.buildSort();
				let path = "/all-offer-list/export?search=" + search
					+ "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			getItemList() {
				let sort = this.buildSort();
				Api.get(this,
					"/all-offer-list/list?search=" + this.search
						+ "&page=" + this.pagination.page
						+ "&result=" + this.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.offers = response.itemList;
							this.itemCount = response.itemCount;
						});
			},

			viewOffer(contestId, offerId) {
				this.$router.openInNewTab("/view/contest/" + contestId + "/offer/" + offerId);
			},

			removeEmptyTableLoading() {
				var el = document.querySelector(".v-datatable__progress");
				el.parentNode.removeChild(el);
			},

			printAllCountries(item) {
				let output = item.mainCountry;
				item.extraCountries.forEach(country => output = output + ', ' + country);
				return output;
			},
		},
			
	};
</script>

<style scoped>

</style>
